import React, { Component } from 'react';

import { connect } from 'react-redux';

import {
  Link,
  Route,
  withRouter
} from "react-router-dom";

import * as Icons from './icons';

class MainAsideMenuJohann extends Component {

  render() {
    const { match, site } = this.props;
    const { url } = match;

    return (<aside className={`menu aside-menu is-aside-toogle`}>
      <div className="menu-aside-header" style={{ minHeight: 100 }}>
        <p className="subtitle is-5 child-to-show">
          {site.name}
        </p>
      </div>
      <ul className="menu-list" style={{ position: 'static' }}>
        <Route
          path={`${url}/home`}
          children={({ match }) => <li className={`${match ? 'is-aside-selected' : '' }`}>
            <Link to={`${url}/home`}>
              <Icons.HomeIcon className="is-mini is-gray"/>
              <span className="child-to-show">Página Inicial</span>
            </Link>
          </li>}
        />
        {(site.userPermissions.permission === 0 || site.userPermissions.permission === 3) && <Route
          path={`${url}/dedoduro`}
          children={({ match }) => <li className={`${match ? 'is-aside-selected' : '' }`}>
            <Link to={`${url}/dedoduro`}>
              <Icons.HandPointRightIcon className="is-mini is-gray"/>
              <span className="child-to-show">Trilha de Auditoria</span>
            </Link>
          </li>}
        />}

        <Route
          path={`${url}/relatorios`}
          children={({ match }) => <li className={`${match ? 'is-aside-selected' : '' }`}>
            <Link to={`${url}/relatorios`}>
              <Icons.FilePDFIcon />
              <span className="child-to-show">Relatórios</span>
            </Link>
          </li>}
        />

        {site.userPermissions.permission === 0 && <Route
          path={`${url}/admin`}
          children={({ match }) => <li className={`${match ? 'is-aside-selected' : '' }`}>
            <Link to={`${url}/admin`}>
              <Icons.CogIcon className="is-mini is-gray"/>
              <span className="child-to-show">Configurações</span>
            </Link>
          </li>}
        />}
      </ul>
    </aside>);
  }
}

function mapStateToProps(state, props) {
  const { match } = props;
  const site = state.sites.all[match.params.siteId] || {};
  return { site };
}

export default withRouter(connect(mapStateToProps)(MainAsideMenuJohann));
